<template>
  <div class="footer">
    <div>Memorizer works the best with Chrome on PC</div>
    <div>
      <el-link style="color: #fff" href="https://xmliszt.github.io/" target="__blank">Li Yuxuan</el-link>
      <span> © 2020</span>
    </div>
    <div>
      <el-link style="color: #fff" icon="el-icon-question" href="https://github.com/xmliszt/memorizer.git" target="__blank"><span>How to use Memorizer? </span><font-awesome-icon :icon="['fab', 'github']" /></el-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  width: 100vw;
  max-width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 10vh;
  padding: 1vh;
  font-size: 1.8vh;
  background-color: #606266;
  color: #fff;
  text-align: center;
  z-index: 99999;
}
</style>